import { computed, ref } from "vue";

export const useOffsetPagination = () => {
  const currentLimit = 20;

  const currentPage = ref(0);
  const totalCount = ref(0);

  const currentOffset = computed(() => currentPage.value * currentLimit);

  const updateCurrentPage = (page: number) => {
    currentPage.value = page;
  };

  const updateTotalCount = (count: number) => {
    totalCount.value = count;
  };

  return {
    currentLimit,
    currentPage,
    totalCount,
    currentOffset,
    updateCurrentPage,
    updateTotalCount,
  };
};
